// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customImgBoxModalWrapper {
    display: none;
    position: fixed;
    z-index: 1051;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: #000c;
}

.customImgBoxModalInnerWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    overflow: hidden;
    animation: lightboxOpen .3s linear;
    position: relative;
    cursor: default;
}

.customImgBoxModalBody {
    position: relative;
    margin: auto;
    width: 90%;
    max-width: 1000px;
}

.customLightBoxImg {
    width: 100%;
    position: relative;
    border-radius: 5px;
    display: none;
}

.customLightBoxImg img {
    width: 100%;
    max-height: calc(100vh - 160px);
    height: auto;
    border-radius: inherit;
}

.singlePaginationBox {
    width: 50px;
    height: 50px;
    background-color: var(--common-gray-bg);
    border-radius: 5px;
    flex-shrink: 0;
    cursor: pointer;
}

.singlePaginationImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.customLightBoxPagination {
    display: flex;
    overflow: auto hidden;
    max-width: 500px;
    margin: auto;
    position: absolute;
    bottom: 10px;
    transform: translateX(-50%);
    left: 50%;
    gap: 4px;
}

.customLightBoxPagination::-webkit-scrollbar {
    height: 5px;
}

.customLightBoxPagination::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

.lightBoxImgCount {
    color: var(--common-primary-white-foreground);
    font-size: 12px;
    text-align: end;
    padding: 5px;
    margin: 0;
}

.customImgBoxModalClose,
.customImgBoxModalClose:hover,
.customImgBoxModalClose:focus {
    background: none;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    display: flex;
    justify-content: end;
    width: 100%;
    margin-bottom: 10px;
    box-shadow: none;
}

.customImgBoxModalClose img {
    height: 20px;
    width: 20px;
}

.lightBoxImgNav {
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 50%;
    left: 20px;
    right: 20px;
    transform: translateY(-50%);
    z-index: 1;
}

.imgBoxPrevBtn,
.imgBoxPrevBtn:hover,
.imgBoxPrevBtn:focus,
.imgBoxNextBtn,
.imgBoxNextBtn:hover,
.imgBoxNextBtn:focus {
    background: none;
    border: none;
    cursor: pointer;
    outline: none;
    width: 50px;
    height: 50px;
    padding: 0;
    cursor: pointer;
}

.singlePaginationBox.singlePaginationBoxActive {
    border: 2px solid var(--primary-link-foreground);
}

/* rtl */
.rtl .imgBoxPrevBtn,
.rtl .imgBoxNextBtn {
    transform: rotate(180deg);
}


@keyframes lightboxOpen {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@media (max-width: 1023px) and (min-width: 768px) {

    .imgBoxPrevBtn,
    .imgBoxPrevBtn:hover,
    .imgBoxPrevBtn:focus,
    .imgBoxNextBtn,
    .imgBoxNextBtn:hover,
    .imgBoxNextBtn:focus {
        width: 36px;
        height: 36px;
    }
}

@media (max-width: 767px) {

    .imgBoxPrevBtn,
    .imgBoxPrevBtn:hover,
    .imgBoxPrevBtn:focus,
    .imgBoxNextBtn,
    .imgBoxNextBtn:hover,
    .imgBoxNextBtn:focus {
        width: 20px;
        height: 20px;
    }
}

@media (max-width: 575px) {
    .customLightBoxPagination {
        max-width: 300px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/customLightBoxSlider.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;IAC3B,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;IAC7C,eAAe;IACf,eAAe;IACf,YAAY;IACZ,SAAS;AACb;;AAEA;;;IAGI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,UAAU;AACd;;AAEA;;;;;;IAMI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,gDAAgD;AACpD;;AAEA,QAAQ;AACR;;IAEI,yBAAyB;AAC7B;;;AAGA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;;IAEI;;;;;;QAMI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;;IAEI;;;;;;QAMI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".customImgBoxModalWrapper {\n    display: none;\n    position: fixed;\n    z-index: 1051;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #000c;\n}\n\n.customImgBoxModalInnerWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    overflow: hidden;\n    animation: lightboxOpen .3s linear;\n    position: relative;\n    cursor: default;\n}\n\n.customImgBoxModalBody {\n    position: relative;\n    margin: auto;\n    width: 90%;\n    max-width: 1000px;\n}\n\n.customLightBoxImg {\n    width: 100%;\n    position: relative;\n    border-radius: 5px;\n    display: none;\n}\n\n.customLightBoxImg img {\n    width: 100%;\n    max-height: calc(100vh - 160px);\n    height: auto;\n    border-radius: inherit;\n}\n\n.singlePaginationBox {\n    width: 50px;\n    height: 50px;\n    background-color: var(--common-gray-bg);\n    border-radius: 5px;\n    flex-shrink: 0;\n    cursor: pointer;\n}\n\n.singlePaginationImg {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.customLightBoxPagination {\n    display: flex;\n    overflow: auto hidden;\n    max-width: 500px;\n    margin: auto;\n    position: absolute;\n    bottom: 10px;\n    transform: translateX(-50%);\n    left: 50%;\n    gap: 4px;\n}\n\n.customLightBoxPagination::-webkit-scrollbar {\n    height: 5px;\n}\n\n.customLightBoxPagination::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 10px;\n}\n\n.lightBoxImgCount {\n    color: var(--common-primary-white-foreground);\n    font-size: 12px;\n    text-align: end;\n    padding: 5px;\n    margin: 0;\n}\n\n.customImgBoxModalClose,\n.customImgBoxModalClose:hover,\n.customImgBoxModalClose:focus {\n    background: none;\n    border: none;\n    cursor: pointer;\n    outline: none;\n    padding: 0;\n    display: flex;\n    justify-content: end;\n    width: 100%;\n    margin-bottom: 10px;\n    box-shadow: none;\n}\n\n.customImgBoxModalClose img {\n    height: 20px;\n    width: 20px;\n}\n\n.lightBoxImgNav {\n    display: flex;\n    justify-content: space-between;\n    position: absolute;\n    top: 50%;\n    left: 20px;\n    right: 20px;\n    transform: translateY(-50%);\n    z-index: 1;\n}\n\n.imgBoxPrevBtn,\n.imgBoxPrevBtn:hover,\n.imgBoxPrevBtn:focus,\n.imgBoxNextBtn,\n.imgBoxNextBtn:hover,\n.imgBoxNextBtn:focus {\n    background: none;\n    border: none;\n    cursor: pointer;\n    outline: none;\n    width: 50px;\n    height: 50px;\n    padding: 0;\n    cursor: pointer;\n}\n\n.singlePaginationBox.singlePaginationBoxActive {\n    border: 2px solid var(--primary-link-foreground);\n}\n\n/* rtl */\n.rtl .imgBoxPrevBtn,\n.rtl .imgBoxNextBtn {\n    transform: rotate(180deg);\n}\n\n\n@keyframes lightboxOpen {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n    .imgBoxPrevBtn,\n    .imgBoxPrevBtn:hover,\n    .imgBoxPrevBtn:focus,\n    .imgBoxNextBtn,\n    .imgBoxNextBtn:hover,\n    .imgBoxNextBtn:focus {\n        width: 36px;\n        height: 36px;\n    }\n}\n\n@media (max-width: 767px) {\n\n    .imgBoxPrevBtn,\n    .imgBoxPrevBtn:hover,\n    .imgBoxPrevBtn:focus,\n    .imgBoxNextBtn,\n    .imgBoxNextBtn:hover,\n    .imgBoxNextBtn:focus {\n        width: 20px;\n        height: 20px;\n    }\n}\n\n@media (max-width: 575px) {\n    .customLightBoxPagination {\n        max-width: 300px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
